import * as React from "react";
import { useMemo } from "react";
import MetaDataContext from "components/common/EntityDataTable/contexts/MetaDataContext";
const MetaDataProvider = ({ children = void 0, meta }) => {
  const contextValue = useMemo(() => ({ meta }), [meta]);
  return /* @__PURE__ */ React.createElement(MetaDataContext.Provider, { value: contextValue }, children);
};
export default MetaDataProvider;
